import { EngineeringPageProvider } from "../../context/EngineeringPageContext";
import ServicePageLayout from "./ServicePageLayout";

export default function Engineering() {
  return (
    <EngineeringPageProvider>
      <ServicePageLayout />
    </EngineeringPageProvider>
  );
}
